import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import { MkpEntityBranchStockBalanceContainer } from '../../../../../models';

@Injectable({
  providedIn: 'root'
})
export class MkpEntityBranchStockBalanceLoginMerchantService extends BaseApiTemplateService<MkpEntityBranchStockBalanceContainer> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mkp/entity-branch-stock-balances/login-merchant-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mkp/entity-branch-stock-balances/login-merchant-ep';
    this.httpClient = http;
  }
}